export default {
	methods: {
		// Removes a list from the screen //LISTDEFAULT
		listClose(idx){
			console.log("In ListClose")
			this.lists.splice(idx, 1)
			if(this.lists.length===0) this.displayDefaultList()
		}
	}
}